import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '../shared/services/session.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
    menuToggled: boolean = false;
    constructor(private sessionService: SessionService, private router: Router) { }

    ngOnInit() {}

    menuToggle(event) {
        this.menuToggled = event;
    }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts